<template>
  <div class="card_cart">
    <div class="image">
      <img :src="cart.offer.image" :alt="cart.offer.title" />
      <div class="details">
        <h6 class="title">{{ cart.offer.title }}</h6>
        <p class="text" v-html="cart.offer.text.substring(0, 60) + ' ...'"></p>
      </div>
    </div>
    <h6 class="price">{{ cart.offer.sale == null ? cart.offer.discount.price : cart.offer.sale.price }} {{$t("egp")}}</h6>
    <div class="quantity">
      <div class="minus" @click="minusQuantity(cart.id)">
        <i class="fa-solid fa-minus"></i>
      </div>
      <p class="number">{{ cart.quantity }}</p>
      <div class="plus" @click="addQuantity(cart.offer.id)">
        <i class="fa-solid fa-plus"></i>
      </div>
    </div>
    <h6 class="sub_total">{{ cart.offer.sale == null ? cart.offer.discount.price : cart.offer.sale.price * cart.quantity }} {{$t("egp")}}</h6>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: "offer-card",
  props: {
    cart: Object,
    callCartMethod: Function
  },
  methods: {
    async minusQuantity(item_id) {
      try {
        const response = await axios.post(`/minus_item/${item_id}`);
        Swal.fire({
          title: "",
          text: response.data.message,
          icon: "success",
        });
        this.data = response.data.data,
        this.callCartMethod();
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.response.data.message,
          icon: "error",
        });
      } finally {
        
      }
    },

    async addQuantity(offer_id) {
      const formData = new FormData();
      formData.append("offer_id", offer_id);
      formData.append("quantity", 1);

      try {
        const response = await axios.post("/cart", formData);
        Swal.fire({
          title: "",
          text: response.data.message,
          icon: "success",
        });
        this.data = response.data.data,
        this.callCartMethod();
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.response.data.message,
          icon: "error",
        });
      } finally {
        
      }
    },
  }
};
</script>

<style></style>
